import React from 'react';
import { CONSTANTS } from '../utils/constants';
import { scrollToOffer } from '../utils/scroll';
import { ShieldCheckIcon, ZapIcon, ClockIcon } from 'lucide-react';
export const HeroSection: React.FC = () => {
  return <section className="min-h-screen flex items-center justify-center pt-28 pb-16 px-4 relative overflow-hidden" style={{
    background: 'radial-gradient(ellipse at 50% 20%, rgba(200,163,78,0.08) 0%, transparent 70%)'
  }} data-id="element-84">
      <div className="absolute top-0 left-0 right-0 h-px" style={{
      background: 'linear-gradient(90deg, transparent, var(--gold), transparent)'
    }} data-id="element-85"></div>

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-86">
        <div className="flex flex-col items-center text-center" data-id="element-87">
          <div className="inline-block border px-5 py-1.5 rounded-full text-xs font-semibold tracking-widest uppercase mb-7 animate-fadeDown" style={{
          borderColor: 'var(--border-gold)',
          color: 'var(--gold)'
        }} data-id="element-88">
            ¡Nuevo 2026!
          </div>

          <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-black leading-tight mb-6 tracking-tight" data-id="element-89">
            Aprendé a{' '}
            <span style={{
            color: 'var(--gold)'
          }} data-id="element-90">
              comprar y vender oro
            </span>
            <br className="hidden sm:block" data-id="element-91" />
            <span className="font-normal italic" data-id="element-92">
              {' '}
              en la calle, sin local y sin experiencia
            </span>
          </h1>

          <p className="text-lg md:text-xl max-w-2xl mb-4 leading-relaxed" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-93">
            La guía completa para arrancar el negocio del oro en Argentina con
            menos de USD 200. Identificá piezas reales, calculá su valor y ganá
            desde la primera operación.
          </p>

          <p className="text-sm mb-9" style={{
          color: 'var(--text-muted)'
        }} data-id="element-94">
            Guía digital + 3 bonos incluidos · Acceso inmediato · Garantía 7
            días
          </p>

          <div className="relative w-full max-w-2xl mx-auto mb-10 group cursor-pointer" onClick={scrollToOffer} data-id="element-95">
            <div className="absolute inset-0 rounded-full blur-3xl opacity-20 group-hover:opacity-30 transition-opacity duration-500" style={{
            background: 'var(--gold)'
          }} data-id="element-96"></div>
            <img src={CONSTANTS.IMAGES.MAIN_PRODUCT} alt="Pack Oro en la Calle" className="relative z-10 w-full h-auto drop-shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-97" />
          </div>

          <button onClick={scrollToOffer} className="font-bold text-lg px-10 py-4 rounded-md uppercase tracking-widest transition-all duration-300 hover:-translate-y-0.5 w-full sm:w-auto" style={{
          background: 'linear-gradient(135deg, var(--gold), var(--gold-dark))',
          color: 'var(--bg-dark)',
          boxShadow: '0 4px 20px rgba(200,163,78,0.3)'
        }} onMouseEnter={e => {
          e.currentTarget.style.boxShadow = '0 8px 35px rgba(200,163,78,0.45)';
          e.currentTarget.style.background = 'linear-gradient(135deg, var(--gold-light), var(--gold))';
        }} onMouseLeave={e => {
          e.currentTarget.style.boxShadow = '0 4px 20px rgba(200,163,78,0.3)';
          e.currentTarget.style.background = 'linear-gradient(135deg, var(--gold), var(--gold-dark))';
        }} data-id="element-98">
            QUIERO ACCEDER AHORA
          </button>

          <div className="mt-4 flex flex-col items-center gap-2" data-id="element-99">
            <p className="text-sm font-medium" style={{
            color: 'var(--text-muted)'
          }} data-id="element-100">
              Pago único · Sin suscripción · Acceso de por vida
            </p>
          </div>
        </div>
      </div>
    </section>;
};